import React from 'react'
import cx from "classnames";
import CheckSpotsList from '../../components/CheckSpotsList/CheckSpotsList';
import 'react-international-phone/style.css';
import { Input } from 'reactstrap';
import { PhoneInput } from 'react-international-phone';
import DropDown from '../DropDown/DropDown';
import { getButtonText, getSelected, handleFieldChange } from '../../services/filters';
import { formSpotNamesConvertor } from '../../services/formNamesConvertor';
import { ModalConsumer } from '../../common/ModalContext';
import Button from '../../components/Button/Button';
import { getSearchOptions } from '../../services/getSearchOptions';
import ModalWithDropDown from '../../components/ModalWithDropDown/ModalWithDropDown';
import styles from './SpotForm.module.scss'
import COUNTRIES from '../../constants/countries';

const SecondStep = ({ state }) => {

  const {
    countries = [],
    setCountries,
    usState = [],
    setUsState,
    address,
    setAddress,
    line2,
    setLine2,
    city,
    setCity,
    postcode,
    setPostcode,
    extraAddresses,
    setExtraAddresses,
    validationError,
    setValidationError,
    changeValidationError,
    cancelValidationError,
    phone,
    setPhone,
    email,
    setEmail,
    headquartersHere,
    setHeadquartersHere,
    linkedin,
    setLinkedin,
    facebook,
    setFacebook
  } = state

  const changeCountries = (value) => {
    setCountries(value);
    if (!(value?.length === 1 && value[0] === "USA")) {
      setUsState([]);
    }
  };

  return (
    <div className={styles.secondStep}>
      <p className={styles.title}>Contact details</p>
      <div className={cx(styles.stepsContainer)}>
        <label className={styles.fieldLabel}>
          <input
            type="checkbox"
            checked={headquartersHere}
            onChange={() => {
              setHeadquartersHere(true);
              setExtraAddresses((current) =>
                (current || []).map((office) => ({ ...office, primary: false }))
              );
            }}
          />{" "}
          Headquarters
        </label>
        <div className={styles.formItem}>
          <div className={styles.dropDownDesktop}>
            <p className={styles.fieldLabel}>Country*</p>
            <DropDown
              name="countries"
              className={styles.autocomplete}
              changeValidationError={changeValidationError}
              onChange={handleFieldChange.bind({
                filter: "countries",
                changeFilter: changeCountries,
                selected: countries,
                cancelValidationError: cancelValidationError,
              })}
              selected={countries}
              onClear={() => {
                setCountries([]);
                setUsState([]);
              }}
              dropDownErrorClass={
                validationError.indexOf("countries") !== -1 &&
                styles.dropDownError
              }
              options={COUNTRIES.filter((option) => option.value !== "all")}
              buttonText={getButtonText(
                countries,
                formSpotNamesConvertor("countries"),
                "countries"
              )}
            />
          </div>
          <div className={styles.dropDownMobile}>
            <ModalConsumer>
              {({ toggleModal }) => (
                <>
                  <p
                    className={cx(styles.fieldLabel, {
                      [styles.labelError]: validationError.includes("countries"),
                    })}
                  >
                    Country*
                  </p>
                  <Button
                    onClick={() => {
                      toggleModal("countries");
                    }}
                    className={cx(
                      styles.filterButton,
                      {
                        [styles.dropDownError]:
                          validationError.includes("countries"),
                      },
                      countries?.length ? styles.labelValue : styles.labelName
                    )}
                  >
                    {getButtonText(countries, "Countries", "countries")}
                  </Button>
                </>
              )}
            </ModalConsumer>
          </div>
        </div>
        {countries?.[0] === "USA" && (
          <div className={styles.formItem}>
            <div className={styles.dropDownDesktop}>
              <p className={styles.fieldLabel}>State*</p>
              <DropDown
                name="usState"
                className={styles.autocomplete}
                changeValidationError={changeValidationError}
                onChange={handleFieldChange.bind({
                  filter: "usState",
                  changeFilter: setUsState,
                  selected: usState,
                  cancelValidationError: cancelValidationError,
                })}
                selected={usState}
                onClear={() => setUsState([])}
                dropDownErrorClass={
                  validationError.indexOf("usState") !== -1 &&
                  styles.dropDownError
                }
                options={getSearchOptions("usState")}
                buttonText={getButtonText(
                  usState,
                  "State",
                  "usState"
                )}
              />
            </div>
            <div className={styles.dropDownMobile}>
              <ModalConsumer>
                {({ toggleModal }) => (
                  <>
                    <p
                      className={cx(styles.fieldLabel, {
                        [styles.labelError]: validationError.includes("usState"),
                      })}
                    >
                      State*
                    </p>
                    <Button
                      onClick={() => {
                        toggleModal("usState");
                      }}
                      className={cx(
                        styles.filterButton,
                        {
                          [styles.dropDownError]:
                            validationError.includes("usState"),
                        },
                        usState?.length ? styles.labelValue : styles.labelName
                      )}
                    >
                      {getButtonText(usState, "State", "usState")}
                    </Button>
                  </>
                )}
              </ModalConsumer>
            </div>
          </div>
        )}
        <div className={cx(styles.formItem)}>
          <p className={styles.fieldLabel}>Address line 1*</p>
          <Input
            name="address"
            placeholder="Address line 1"
            value={address}
            onChange={(event) => {
              setAddress(event.target.value);
              setValidationError(
                validationError.filter((errorItem) => errorItem !== "address")
              )
            }}
            className={cx(styles.input, {
              [styles.inputError]: validationError.includes("address"),
            })}
          />
        </div>
        <div className={cx(styles.formItem)}>
          <p className={styles.fieldLabel}>Address line 2</p>
          <Input name="line2" placeholder="Address line 2" value={line2 || ""} onChange={(event) => setLine2(event.target.value)} className={styles.input} />
        </div>
        <div className={cx(styles.formItem)}>
          <p className={styles.fieldLabel}>City</p>
          <Input name="city" placeholder="City" value={city || ""} onChange={(event) => setCity(event.target.value)} className={styles.input} />
        </div>
        <div className={cx(styles.formItem)}>
          <p className={styles.fieldLabel}>Postcode</p>
          <Input name="postcode" placeholder="Postcode" value={postcode || ""} onChange={(event) => setPostcode(event.target.value)} className={styles.input} />
        </div>
        <div className={cx(styles.formItem)}>
          <p className={styles.fieldLabel}>Email</p>
          <Input
            name="email"
            placeholder="name@company.com"
            value={email || ""}
            onChange={(event) => {
              setEmail(event.target.value);
              setValidationError(
                validationError.filter((errorItem) => errorItem !== "email")
              );
            }}
            className={cx(styles.input, {
              [styles.inputError]: validationError.includes("email"),
            })}
          />
        </div>
        <div className={styles.formItem}>
          <p className={styles.fieldLabel}>Phone</p>
          <PhoneInput
            defaultCountry="us"
            value={phone}
            onChange={(nextPhone) => nextPhone.length > 2 && setPhone(nextPhone)}
          />
        </div>
        {(extraAddresses || []).map((office, index) => {
          const updateOffice = (patch) => {
            setExtraAddresses((current) => {
              const next = [...(current || [])];
              next[index] = { ...(next[index] || {}), ...patch };
              return next;
            });
          };
          const officeCountry = office.country ? [office.country] : [];
          const officeState = office.state ? [office.state] : [];
          return (
          <div key={`office-${index}`} className={styles.extraOffice}>
            <p className={styles.fieldLabel}>Office {index + 2}</p>
            <label className={styles.fieldLabel}>
              <input
                type="checkbox"
                checked={!headquartersHere && Boolean(office.primary)}
                onChange={() => {
                  setHeadquartersHere(false);
                  setExtraAddresses((current) =>
                    (current || []).map((item, itemIndex) => ({
                      ...item,
                      primary: itemIndex === index,
                    }))
                  );
                }}
              />{" "}
              Headquarters
            </label>
            <div className={styles.formItem}>
              <p className={styles.fieldLabel}>Country</p>
              <DropDown
                name={`officeCountry${index}`}
                className={styles.autocomplete}
                onChange={(value) => updateOffice({
                  country: value || "",
                  state: value === "USA" ? office.state : "",
                  loc: undefined,
                  location: undefined,
                })}
                selected={officeCountry}
                onClear={() => updateOffice({ country: "", state: "", loc: undefined, location: undefined })}
                options={COUNTRIES.filter((option) => option.value !== "all")}
                buttonText={getButtonText(officeCountry, "Country", "countries")}
              />
            </div>
            {office.country === "USA" && (
              <div className={styles.formItem}>
                <p className={styles.fieldLabel}>State</p>
                <DropDown
                  name={`officeState${index}`}
                  className={styles.autocomplete}
                  onChange={(value) => updateOffice({ state: value || "" })}
                  selected={officeState}
                  onClear={() => updateOffice({ state: "" })}
                  options={getSearchOptions("usState")}
                  buttonText={getButtonText(officeState, "State", "usState")}
                />
              </div>
            )}
            <Input className={styles.input} placeholder="City" value={office.city || ""} onChange={(event) => updateOffice({ city: event.target.value })} />
            <Input className={styles.input} placeholder="Address line 1" value={office.line1 || ""} onChange={(event) => updateOffice({ line1: event.target.value, loc: undefined, location: undefined })} />
            <Input className={styles.input} placeholder="Address line 2" value={office.line2 || ""} onChange={(event) => updateOffice({ line2: event.target.value })} />
            <Input className={styles.input} placeholder="Postcode" value={office.postcode || ""} onChange={(event) => updateOffice({ postcode: event.target.value })} />
            <Input className={styles.input} placeholder="Email" value={office.email || ""} onChange={(event) => updateOffice({ email: event.target.value })} />
            <PhoneInput defaultCountry="us" value={office.phone || ""} onChange={(nextPhone) => nextPhone.length > 2 && updateOffice({ phone: nextPhone })} />
            <Button type="button" className={styles.removeAddress} onClick={() => setExtraAddresses((current) => (current || []).filter((_, item) => item !== index))}>Remove office</Button>
          </div>
          );
        })}
        <Button type="button" className={styles.addAddress} onClick={() => setExtraAddresses((current) => [...(current || []), { country: "", state: "", city: "", line1: "", line2: "", postcode: "", primary: false }])}>Add another address</Button>




        <ModalConsumer>
          {({ isOpen, toggleModal, modalId }) => {
            return (
              (modalId === "countries" || modalId === "usState") && (
                <ModalWithDropDown
                  onSave={toggleModal}
                  toggleModal={toggleModal}
                  isOpen={isOpen}
                  name={modalId}
                  options={getSearchOptions(modalId).filter(
                    (option) => option.value !== "all"
                  )}
                  selected={getSelected({
                    modalId,
                    countries,
                    usState
                  })}
                  onChange={handleFieldChange.bind({
                    filter: modalId,
                    changeFilter: (value) =>
                      modalId === "usState"
                        ? setUsState(value)
                        : changeCountries(value),
                    selected: getSelected({
                      modalId,
                      countries,
                      usState
                    }),
                    cancelValidationError: cancelValidationError,
                  })}
                  onClear={() =>
                    modalId === "usState"
                      ? setUsState([])
                      : changeCountries([])
                  }
                  changeValidationError={changeValidationError}
                />
              )
            );
          }}
        </ModalConsumer>
      </div>

      <div className={cx(styles.stepsContainer, styles.spaceTop)}>
        <p className={styles.title}>Social media</p>
        <div className={cx(styles.formItem)}>
          <p className={styles.fieldLabel}>linkedIn</p>
          <Input
            name="linkedin"
            placeholder="Linkedin"
            value={linkedin}
            onChange={(event) => {
              setLinkedin(event.target.value);
            }}
            className={cx(styles.input)}

          />
        </div>
        <div className={cx(styles.formItem)}>
          <p className={styles.fieldLabel}>facebook</p>
          <Input
            name="facebook"
            placeholder="Facebook"
            value={facebook}
            onChange={(event) => {
              setFacebook(event.target.value);
            }}
            className={cx(styles.input)}

          />
        </div>
      </div>
    </div>
  )
}

export default SecondStep
